/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { EmployeeProfileRoleDto } from '../models';
// @ts-ignore
import type { EmployeeSectionResponseDto } from '../models';
// @ts-ignore
import type { LanguageDto } from '../models';
// @ts-ignore
import type { SectionTypeDto } from '../models';
/**
 * RestEmployeeSectionsReaderApi - axios parameter creator
 * @export
 */
export const RestEmployeeSectionsReaderApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieve a specific section of employee data based on section type
         * @summary Get Employee Section
         * @param {string} employeeId 
         * @param {SectionTypeDto} sectionType Type of employee section to retrieve
         * @param {EmployeeProfileRoleDto} role The role with which user wants to view the employee profile
         * @param {LanguageDto} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeeSection: async (employeeId: string, sectionType: SectionTypeDto, role: EmployeeProfileRoleDto, lang?: LanguageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('getEmployeeSection', 'employeeId', employeeId)
            // verify required parameter 'sectionType' is not null or undefined
            assertParamExists('getEmployeeSection', 'sectionType', sectionType)
            // verify required parameter 'role' is not null or undefined
            assertParamExists('getEmployeeSection', 'role', role)
            const localVarPath = `/api/v2/employees/{employeeId}/sections/{sectionType}`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)))
                .replace(`{${"sectionType"}}`, encodeURIComponent(String(sectionType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (role !== undefined) {
                localVarQueryParameter['role'] = role;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve list of all supported employee section types
         * @summary Get Supported Section Types
         * @param {string} employeeId 
         * @param {EmployeeProfileRoleDto} role The role with which user wants to view the employee profile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupportedSectionTypes: async (employeeId: string, role: EmployeeProfileRoleDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('getSupportedSectionTypes', 'employeeId', employeeId)
            // verify required parameter 'role' is not null or undefined
            assertParamExists('getSupportedSectionTypes', 'role', role)
            const localVarPath = `/api/v2/employees/{employeeId}/sections/supported`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (role !== undefined) {
                localVarQueryParameter['role'] = role;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RestEmployeeSectionsReaderApi - functional programming interface
 * @export
 */
export const RestEmployeeSectionsReaderApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RestEmployeeSectionsReaderApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieve a specific section of employee data based on section type
         * @summary Get Employee Section
         * @param {string} employeeId 
         * @param {SectionTypeDto} sectionType Type of employee section to retrieve
         * @param {EmployeeProfileRoleDto} role The role with which user wants to view the employee profile
         * @param {LanguageDto} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmployeeSection(employeeId: string, sectionType: SectionTypeDto, role: EmployeeProfileRoleDto, lang?: LanguageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeSectionResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEmployeeSection(employeeId, sectionType, role, lang, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestEmployeeSectionsReaderApi.getEmployeeSection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve list of all supported employee section types
         * @summary Get Supported Section Types
         * @param {string} employeeId 
         * @param {EmployeeProfileRoleDto} role The role with which user wants to view the employee profile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSupportedSectionTypes(employeeId: string, role: EmployeeProfileRoleDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SectionTypeDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSupportedSectionTypes(employeeId, role, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestEmployeeSectionsReaderApi.getSupportedSectionTypes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RestEmployeeSectionsReaderApi - factory interface
 * @export
 */
export const RestEmployeeSectionsReaderApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RestEmployeeSectionsReaderApiFp(configuration)
    return {
        /**
         * Retrieve a specific section of employee data based on section type
         * @summary Get Employee Section
         * @param {string} employeeId 
         * @param {SectionTypeDto} sectionType Type of employee section to retrieve
         * @param {EmployeeProfileRoleDto} role The role with which user wants to view the employee profile
         * @param {LanguageDto} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeeSection(employeeId: string, sectionType: SectionTypeDto, role: EmployeeProfileRoleDto, lang?: LanguageDto, options?: RawAxiosRequestConfig): AxiosPromise<EmployeeSectionResponseDto> {
            return localVarFp.getEmployeeSection(employeeId, sectionType, role, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve list of all supported employee section types
         * @summary Get Supported Section Types
         * @param {string} employeeId 
         * @param {EmployeeProfileRoleDto} role The role with which user wants to view the employee profile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupportedSectionTypes(employeeId: string, role: EmployeeProfileRoleDto, options?: RawAxiosRequestConfig): AxiosPromise<Array<SectionTypeDto>> {
            return localVarFp.getSupportedSectionTypes(employeeId, role, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RestEmployeeSectionsReaderApi - interface
 * @export
 * @interface RestEmployeeSectionsReaderApi
 */
export interface RestEmployeeSectionsReaderApiInterface {
    /**
     * Retrieve a specific section of employee data based on section type
     * @summary Get Employee Section
     * @param {string} employeeId 
     * @param {SectionTypeDto} sectionType Type of employee section to retrieve
     * @param {EmployeeProfileRoleDto} role The role with which user wants to view the employee profile
     * @param {LanguageDto} [lang] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestEmployeeSectionsReaderApiInterface
     */
    getEmployeeSection(employeeId: string, sectionType: SectionTypeDto, role: EmployeeProfileRoleDto, lang?: LanguageDto, options?: RawAxiosRequestConfig): AxiosPromise<EmployeeSectionResponseDto>;

    /**
     * Retrieve list of all supported employee section types
     * @summary Get Supported Section Types
     * @param {string} employeeId 
     * @param {EmployeeProfileRoleDto} role The role with which user wants to view the employee profile
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestEmployeeSectionsReaderApiInterface
     */
    getSupportedSectionTypes(employeeId: string, role: EmployeeProfileRoleDto, options?: RawAxiosRequestConfig): AxiosPromise<Array<SectionTypeDto>>;

}

/**
 * RestEmployeeSectionsReaderApi - object-oriented interface
 * @export
 * @class RestEmployeeSectionsReaderApi
 * @extends {BaseAPI}
 */
export class RestEmployeeSectionsReaderApi extends BaseAPI implements RestEmployeeSectionsReaderApiInterface {
    /**
     * Retrieve a specific section of employee data based on section type
     * @summary Get Employee Section
     * @param {string} employeeId 
     * @param {SectionTypeDto} sectionType Type of employee section to retrieve
     * @param {EmployeeProfileRoleDto} role The role with which user wants to view the employee profile
     * @param {LanguageDto} [lang] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestEmployeeSectionsReaderApi
     */
    public getEmployeeSection(employeeId: string, sectionType: SectionTypeDto, role: EmployeeProfileRoleDto, lang?: LanguageDto, options?: RawAxiosRequestConfig) {
        return RestEmployeeSectionsReaderApiFp(this.configuration).getEmployeeSection(employeeId, sectionType, role, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve list of all supported employee section types
     * @summary Get Supported Section Types
     * @param {string} employeeId 
     * @param {EmployeeProfileRoleDto} role The role with which user wants to view the employee profile
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestEmployeeSectionsReaderApi
     */
    public getSupportedSectionTypes(employeeId: string, role: EmployeeProfileRoleDto, options?: RawAxiosRequestConfig) {
        return RestEmployeeSectionsReaderApiFp(this.configuration).getSupportedSectionTypes(employeeId, role, options).then((request) => request(this.axios, this.basePath));
    }
}

